var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFindTalent(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 841.499,
    height: 544.659,
    viewBox: "0 0 841.499 544.659",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.501 1)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 540.975)"
  }, /*#__PURE__*/React.createElement("line", {
    x2: 44.726,
    y2: 0.116,
    transform: "translate(795.771 2.066)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    x2: 779.873,
    y2: 2.024,
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(16.452 64.843)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(601.31)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38.054,
    height: 15.93,
    transform: "translate(20.354)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 38.054,
    height: 15.93,
    transform: "translate(0 20.355)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 38.054,
    height: 15.93,
    transform: "translate(42.479 20.355)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.126 292.154)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38.054,
    height: 15.93,
    transform: "translate(20.355)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.638,346.306H58.132v-15.93H96.186v15.93H80.139",
    transform: "translate(-58.132 -310.022)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 38.054,
    height: 15.93,
    transform: "translate(42.479 20.355)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(713.157 176.564)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38.054,
    height: 15.93,
    transform: "translate(20.355)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M622.194,257.349H604.567v-15.93h38.054v15.93H629.544",
    transform: "translate(-604.567 -221.065)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 38.054,
    height: 15.93,
    transform: "translate(42.479 20.355)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(130.591 176.564)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38.054,
    height: 15.93,
    transform: "translate(20.355)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.479,257.349H156.228v-15.93h38.054v15.93h-13.3",
    transform: "translate(-156.228 -221.065)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 38.054,
    height: 15.93,
    transform: "translate(42.479 20.355)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(713.395 286.301)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38.054,
    height: 15.93,
    transform: "translate(20.354)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 38.054,
    height: 15.93,
    transform: "translate(0 20.355)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M665.906,325.872h9.59V341.8H637.441v-15.93h19.013",
    transform: "translate(-594.962 -305.517)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(361.832 286.301)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38.054,
    height: 15.93,
    transform: "translate(20.355)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.116,341.8H334.19v-15.93h38.054V341.8h-17.2",
    transform: "translate(-334.19 -305.517)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 38.054,
    height: 15.93,
    transform: "translate(42.479 20.355)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(361.832 386.7)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M376.079,387.474h11.83V403.4H349.854v-15.93h16.773",
    transform: "translate(-329.5 -387.474)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 38.054,
    height: 15.93,
    transform: "translate(0 20.355)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 38.054,
    height: 15.93,
    transform: "translate(42.479 20.355)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(277.232 386.7)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38.054,
    height: 15.93,
    transform: "translate(20.355)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 38.054,
    height: 15.93,
    transform: "translate(0 20.355)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.493,419.068h-15.72v-15.93h38.054v15.93H327.994",
    transform: "translate(-259.294 -382.784)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(537.149 20.355)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38.054,
    height: 15.93,
    transform: "translate(20.354)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 38.054,
    height: 15.93,
    transform: "translate(0 20.355)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 38.054,
    height: 15.93,
    transform: "translate(42.479 20.355)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 33.851)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38.054,
    height: 15.93,
    transform: "translate(20.355)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 38.054,
    height: 15.93,
    transform: "translate(0 20.355)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.6,131.588h12.872v15.93H88.418v-15.93H105.2",
    transform: "translate(-45.939 -111.234)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(537.149 99.466)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38.054,
    height: 15.93,
    transform: "translate(20.354)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 38.054,
    height: 15.93,
    transform: "translate(0 20.355)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 38.054,
    height: 15.93,
    transform: "translate(42.479 20.355)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(713.395 327.104)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38.054,
    height: 15.93,
    transform: "translate(20.354)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 38.054,
    height: 15.93,
    transform: "translate(0 20.354)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M655.93,373.2H637.441v-15.93H675.5V373.2H662.23",
    transform: "translate(-594.962 -336.919)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(532.267 133.808)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M506.956,285.519s14.493,23.163,20.558,45.568c4.31,15.928,4.5,129.622,4.5,129.622s.292-175.875,21.876-212.193",
    transform: "translate(-436.449 -111.341)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M565.7,186.025s-20.9,33.576-26.723,68.523S527.83,475.617,527.83,475.617c-.343-18.159.868-184.066-4.956-212.846a215.3,215.3,0,0,0-16.445-49.679",
    transform: "translate(-436.607 -130.05)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 15.035)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M527.05,232.722s17.491.81,25.657-12.321,2.8-25.681-4.881-26.6-11.01,8.577-13.855,4.023,8.167-13.13-4.172-21.019-18.09,3.425-22-.616-1.093-14.6-9.241-19.243-11.952,1.136-16.464,1.328-18.711-7.458-24.377-1.449,7.894,20.547,1.522,20.976-8.957,12.852-3.78,20.892,21.834,11.222,18.584,15.413-19.158,3.938-12.677,13.324,28.484,10,31.648,11.114-10.135,3.551-7.887,12.339,20.529,9.875,32.289,4.228S527.05,232.722,527.05,232.722Z",
    transform: "translate(-452.694 -154.518)",
    fill: "#8db0fc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.078,169.127s37.151,24.284,50.468,59.221",
    transform: "translate(-447.19 -150.145)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.676,186.416l24.906,2.43-6.075-20.654",
    transform: "translate(-447.61 -150.425)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.1,209.369h24.906l1.822-22.476",
    transform: "translate(-442.991 -144.826)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(101.447)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M554.908,206.431s-14.2.656-20.828-10-2.27-20.847,3.962-21.592,8.938,6.962,11.247,3.265-6.629-10.66,3.388-17.062,14.684,2.779,17.861-.5.887-11.856,7.5-15.621,9.7.921,13.365,1.078,15.19-6.055,19.788-1.176-6.407,16.679-1.236,17.027,7.271,10.434,3.069,16.96-17.724,9.11-15.086,12.512,15.552,3.2,10.291,10.816-23.123,8.12-25.692,9.022,8.228,2.883,6.4,10.017-16.665,8.016-26.211,3.432S554.908,206.431,554.908,206.431Z",
    transform: "translate(-530.767 -142.947)",
    fill: "#8db0fc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590.314,154.806s-30.159,19.713-40.968,48.075",
    transform: "translate(-525.205 -139.397)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M586.672,168.841l-20.218,1.972,4.931-16.766",
    transform: "translate(-520.083 -139.624)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.489,187.473H554.271l-1.48-18.246",
    transform: "translate(-524.173 -135.079)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(30.172 139.127)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M524.881,301.52s11.519.533,16.9-8.115,1.841-16.912-3.214-17.517-7.252,5.648-9.124,2.649,5.377-8.647-2.75-13.842-11.913,2.256-14.489-.405-.72-9.618-6.086-12.673-7.872.748-10.842.876-12.323-4.913-16.054-.955,5.2,13.532,1,13.814-5.9,8.464-2.49,13.759,14.379,7.39,12.239,10.151-12.617,2.594-8.349,8.773,18.758,6.588,20.842,7.32-6.674,2.339-5.195,8.126,13.52,6.5,21.264,2.785S524.881,301.52,524.881,301.52Z",
    transform: "translate(-475.915 -250.019)",
    fill: "#c12f33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.022,259.64s24.465,15.993,33.234,39",
    transform: "translate(-472.29 -247.138)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M487.1,271.026l16.4,1.6-4-13.6",
    transform: "translate(-472.567 -247.323)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.258,286.141h16.4l1.2-14.8",
    transform: "translate(-469.525 -243.636)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(68.084 207.451)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M529.44,366.63s-14.322.663-21.007-10.088-2.289-21.027,4-21.778,9.015,7.022,11.344,3.293-6.685-10.751,3.417-17.209,14.81,2.8,18.015-.5.9-11.957,7.566-15.755,9.787.929,13.48,1.088,15.321-6.107,19.959-1.186-6.463,16.823-1.246,17.174,7.334,10.524,3.1,17.105-17.877,9.188-15.217,12.62,15.686,3.225,10.381,10.91-23.321,8.189-25.912,9.1,8.3,2.908,6.458,10.1-16.808,8.086-26.436,3.462S529.44,366.63,529.44,366.63Z",
    transform: "translate(-505.091 -302.6)",
    fill: "#c12f33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M565.151,314.561s-30.419,19.883-41.321,48.488",
    transform: "translate(-499.481 -299.019)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561.476,328.717l-20.392,1.989,4.973-16.91",
    transform: "translate(-494.315 -299.248)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.189,347.509H528.8l-1.492-18.4",
    transform: "translate(-498.441 -294.664)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(88.269 75.218)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M545.655,271.137S528.3,268.8,522.616,254.424s1.844-25.767,9.561-25.3,9.3,10.407,12.912,6.436-5.685-14.38,7.867-19.933,17.184,6.6,21.758,3.33,3.689-14.174,12.534-17.279,11.558,3.255,15.962,4.253,19.744-3.992,24.243,2.934-11.442,18.8-5.249,20.365,6.513,14.249-.018,21.232-23.489,7.135-21.042,11.84,18.145,7.3,10.09,15.377-29.813,4.745-33.126,5.272,9.336,5.308,5.553,13.551-21.965,6.043-32.525-1.616S545.655,271.137,545.655,271.137Z",
    transform: "translate(-520.625 -200.835)",
    fill: "#8db0fc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.137,217.047s-40.9,17.245-60.249,49.236",
    transform: "translate(-514.858 -195.981)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M591.039,235.084,566.1,233.019l9.672-19.234",
    transform: "translate(-507.01 -196.958)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571.829,255.232l-24.5-4.456,2.228-22.44",
    transform: "translate(-512.631 -192.601)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("path", {
    d: "M504.817,406.1c-1.241,3.339-1.953,31.757-1.953,35.53,0,24.99,13.786,30.79,30.791,30.79s30.792-4.462,30.792-30.79c0-3.773-.712-32.191-1.953-35.53Z",
    transform: "translate(-437.674 -64.162)",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(137.355 0)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 172.116,
    height: 216.101,
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.011,198.506V49.058h73.88",
    transform: "translate(-146.606 -37.249)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.275,49.058h65.041V241.542H156.011V210.106",
    transform: "translate(-146.606 -37.249)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.853,143.723v35.714h-72.9V87.9h72.9v43.292",
    transform: "translate(-137.343 -25.619)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(81.79 293.276)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M208.922,350.815,228.473,486.11a1.942,1.942,0,0,0,1.923,1.666h0a1.943,1.943,0,0,0,1.928-2.173l-16.088-133.5Z",
    transform: "translate(-75.2 -240.183)",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.469,338.8s21.064-2.34,40.1-.3c8,.858,36.236,3.065,35.33,9.7s-6.934,9.345-8.139,9.345-113.963,7.839-115.772,6.03-3.617-6.03-2.412-8.442S183.469,338.8,183.469,338.8Z",
    transform: "translate(-98.174 -244.121)",
    fill: "#b8b8b8",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.149,265.718a3.033,3.033,0,0,0-3.393,3.732c4.544,19.053,25.134,104.985,27.335,107.185,2.475,2.475,12.873,7.426,17.329,6.931s26.24-7.426,42.083-20.794,26.24-27.725,25.25-36.636-6.436-16.834-11.388-17.824-24.755.5-42.082-4.951S133.6,289,125.676,278.112C119.734,269.943,114.628,266.508,110.149,265.718Z",
    transform: "translate(-105.812 -265.673)",
    fill: "#b8b8b8",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.329,318.389l4.8,50.764L106.067,496.136a1.666,1.666,0,0,0,1.61,2.093h0A1.666,1.666,0,0,0,109.286,497l33.537-127.2,16.893-.641v-3.442l-17.208-1.29L132.885,317.9a1.3,1.3,0,0,0-1.119-1.028h0A1.3,1.3,0,0,0,130.329,318.389Z",
    transform: "translate(-106.01 -250.347)",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(454.114)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M481.685,350.815,462.136,486.11a1.942,1.942,0,0,1-1.923,1.666h0a1.942,1.942,0,0,1-1.928-2.173l16.088-133.5Z",
    transform: "translate(-454.662 -240.183)",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530.944,338.8s-21.066-2.34-40.1-.3c-8,.858-36.236,3.065-35.332,9.7s6.935,9.345,8.141,9.345,113.962,7.839,115.772,6.03,3.617-6.03,2.412-8.442S530.944,338.8,530.944,338.8Z",
    transform: "translate(-455.494 -244.121)",
    fill: "#b8b8b8",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.9,265.718a3.033,3.033,0,0,1,3.393,3.732c-4.545,19.053-25.135,104.985-27.335,107.185-2.477,2.475-12.873,7.426-17.329,6.931s-26.24-7.426-42.083-20.794-26.24-27.725-25.25-36.636,6.436-16.834,11.387-17.824,24.755.5,42.083-4.951,31.687-14.358,39.608-25.25C591.318,269.943,596.424,266.508,600.9,265.718Z",
    transform: "translate(-444.494 -265.673)",
    fill: "#b8b8b8",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567.258,318.389l-4.8,50.764L591.52,496.136a1.667,1.667,0,0,1-1.61,2.093h0A1.666,1.666,0,0,1,588.3,497l-33.537-127.2-16.895-.641v-3.442l17.208-1.29L564.7,317.9a1.3,1.3,0,0,1,1.119-1.028h0A1.3,1.3,0,0,1,567.258,318.389Z",
    transform: "translate(-430.831 -250.347)",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(175.162 316.385)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M203.007,505.834H194L189.49,295.8h18.023Z",
    transform: "translate(-174.39 -279.763)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.773,308.97H207.23l.283-13.17H189.49Z",
    transform: "translate(-174.39 -279.763)",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.415,505.834H487.4L482.9,295.8h18.023Z",
    transform: "translate(-86.547 -279.763)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.18,308.97h17.458l.282-13.17H482.9Z",
    transform: "translate(-86.547 -279.763)",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 410.982,
    height: 21.872,
    transform: "translate(8.951)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 410.982,
    height: 10.936,
    transform: "translate(8.951)",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 428.884,
    height: 8.313,
    fill: "#e6e6e6",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(243.611 22.521)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(94.327 20.002)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(47.932 146.665)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M361.283,214.6s5.114,4.649,6.509,5.113,4.029,1.085,4.029,1.085l2.944.62-6.509-9.452Z",
    transform: "translate(-333.664 -177.663)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.028,187.619l60.339,63.213,19.087-8.415-40.226-56.85Z",
    transform: "translate(-340.028 -185.567)",
    fill: "#b8b8b8",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.836,189.4l38.832,42.449,23.6-3.046-30.837-41.688Z",
    transform: "translate(-338.588 -185.104)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.25,209.146a16.054,16.054,0,0,1-1.457-2.434,31.273,31.273,0,0,1,.742-4.891c.222-.668.889-.89,1.481.444a6.513,6.513,0,0,1,.52,3.113,14.713,14.713,0,0,0,.592,2.3l-1.483,2.075Z",
    transform: "translate(-335.609 -180.86)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.8,212.409s-2.886-3.341-2.886-3.949a29.108,29.108,0,0,1,1.746-4.026c.077-.227,3.874-.455,4.482-.683s1.9-.379,1.594.608a3.232,3.232,0,0,1-1.823,2.126,10.042,10.042,0,0,0-1.9,1.064l-.227,1.063,1.063,1.519",
    transform: "translate(-335.272 -180.174)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.552,214.64s-3.237-3.747-3.237-4.428,1.874-4.257,1.959-4.513,4.343-.511,5.023-.767,2.128-.426,1.788.681A3.626,3.626,0,0,1,364.042,208a11.277,11.277,0,0,0-2.128,1.193l-.256,1.192,1.193,1.7",
    transform: "translate(-334.852 -179.826)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.2,217.213s-3.918-4.088-3.918-4.514a40.3,40.3,0,0,1,2.044-4.257s7.92-1.277,8.345-1.193.682.6-.6,1.788a9.386,9.386,0,0,1-3.918,1.7c-.511.17-.6,2.384-.6,2.384l2.384,2.981",
    transform: "translate(-334.264 -179.077)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 171.768)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M344.74,214.314a35.781,35.781,0,0,0-6.44,3.08c-2.52,1.679-6.719,3.919-6.719,3.919l-4.315,14.755a18.132,18.132,0,0,1,9.354,3.164c4.2,3.08,13.159,2.24,15.4.839s5.32-12.318,2.52-14.838S344.74,214.314,344.74,214.314Z",
    transform: "translate(-295.917 -202.063)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.116,225.1l-7.839-2.52s-5.88-3.92-7.279-4.48-6.44-.559-6.44-.559-13.438,19.318-14,20.717-.839,4.479,1.12,5.039,6.719-1.12,6.719-1.12,4.48,2.24,7.279,1.68,11.2-6.44,11.2-6.44l9.8-.279Z",
    transform: "translate(-293.857 -201.096)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.894,219.9s6.16,9.519,8.4,9.8,4.48-1.12,2.8-4.2-3.64-7.839-4.76-10.36-5.6-2.52-7.559,1.68",
    transform: "translate(-292.471 -202.331)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(53.312 31.322)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M352.835,229.684a4.244,4.244,0,0,0-.338,4.895c.678,1.158,1.453,2.362,1.736,2.362.546,0,2.912-.583,2.73-2.913C356.813,232.112,355.067,227.184,352.835,229.684Z",
    transform: "translate(-341.859 -228.991)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.31,232.427a4.247,4.247,0,0,0-.339,4.895c.68,1.159,1.454,2.362,1.737,2.362.546,0,2.912-.582,2.73-2.913C354.288,234.857,352.542,229.929,350.31,232.427Z",
    transform: "translate(-342.615 -228.169)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.361,235.162a3.428,3.428,0,0,0-.273,3.951c.548.934,1.173,1.906,1.4,1.906a2.266,2.266,0,0,0,2.2-2.352C350.573,237.122,349.163,233.145,347.361,235.162Z",
    transform: "translate(-343.443 -227.311)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.757,236.318a2.628,2.628,0,0,0-.209,3.025c.42.716.9,1.459,1.073,1.459a1.734,1.734,0,0,0,1.687-1.8C347.215,237.819,346.137,234.775,344.757,236.318Z",
    transform: "translate(-344.168 -226.925)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("path", {
    d: "M333.988,218.784l-3.563,19.137-6.8-.3,4.154-20.615Z",
    transform: "translate(-297.007 -201.256)",
    fill: "#8db0fc",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.391,217.979s-3.267,23.867-5.042,25.937-25.724-4.435-26.906-4.731,1.479-34.3,1.479-34.3S332.73,216.8,335.391,217.979Z",
    transform: "translate(-303.14 -204.886)",
    fill: "#8db0fc",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(103.394 17.83)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M392.824,90.579s-4.353,10.1-4.353,14.1.348,9.925-.7,13.059-6.094,4.874-4.875,7.486,4.7,4.179,4.7,4.179,2.438,12.537,3.831,16.367,3.656,4.352,5.745,4,7.487-1.741,7.487-1.741l4,20.72,26.29-14.626-4.353-13.58s7.487-13.059-.522-31.34S404.837,79.958,392.824,90.579Z",
    transform: "translate(-382.711 -86.417)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.165,105.469s1.423-2.786,4.126-1.393",
    transform: "translate(-380.779 -81.247)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.209,
    cy: 2.612,
    rx: 1.209,
    ry: 2.612,
    transform: "translate(9.94 27.144)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.824,122.647s6.789-.174,9.923-4.353",
    transform: "translate(-380.581 -76.873)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("path", {
    d: "M430.849,134.355s-29.957,18.2-31.077,19.6-1.959,10.638-1.959,10.638l37.516-24.638Z",
    transform: "translate(-274.796 -54.234)",
    fill: "#3e2a2a",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.379,325.623s-2.442,17.7-1.527,22.586,30.521,94.892,30.827,97.944,3.052,17.092,3.052,17.092-6.1,10.682-7.326,14.955-6.714,8.851-8.85,10.377-9.157,4.274-10.073,5.494,2.157.98,4.131,1.406,9.3.121,9.3.121,8.546.3,10.988-.611,5.8-10.072,7.326-11.9a8.448,8.448,0,0,1,3.967-2.442l-2.747,15.565h4.274s3.051-12.513,4.272-16.786,2.747-6.715.916-10.988a64.092,64.092,0,0,0-5.494-9.462s-1.221-34.183-.916-35.708-2.136-31.437-3.052-39.373-7.63-28.967-7.935-30.8,1.831-22.586,1.831-22.586Z",
    transform: "translate(-278.139 3.029)",
    fill: "#eaeaea",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(120.216 331.208)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M408.208,329.54s3.473,25.731,5.454,36.543,9.9,82.247,9.386,88.712a75.762,75.762,0,0,1-1.118,9.2s-8.69,18.221-10.673,20.311-5.392,6.559-7.419,6.952-9.671,1.642-7.921,3.634,20.428,2.182,24.473,1.058,9.252-9.748,10.921-10.811l1.67-1.062,1.32,11.509,4.41-.116s3.458-10.615,3.28-17.4-4.444-14.144-4.444-14.144,4.486-23.2,7.131-38.892,7.434-27.355,4.061-39.49-4.613-20.59-4.639-21.608,2-36.343,2-36.343S417.153,334.06,408.208,329.54Z",
    transform: "translate(-395.657 -327.59)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.989,445.649a29.076,29.076,0,0,0-2.357-9.782c-.447.157-.893.314-1.385.511-5.265,2.1-13.255,12.386-19.831,17.878a17.725,17.725,0,0,1-13.467,4.271l-.164-.1a3.01,3.01,0,0,1-.948.408c-2.027.392-9.671,1.642-7.921,3.634s20.428,2.182,24.473,1.058,9.252-9.748,10.921-10.811l1.67-1.062,1.32,11.509,4.41-.116S442.167,452.434,441.989,445.649Z",
    transform: "translate(-395.657 -295.173)",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("path", {
    d: "M384.157,250.807l2.714,27.491L379.4,359.109s27.152,11.54,49.552,10.182,34.618-7.805,34.618-7.805-3.054-59.43-2.714-62.824,4.411-16.631,1.017-31.565-6.788-20.7-6.788-20.7S407.915,258.612,384.157,250.807Z",
    transform: "translate(-280.307 -20.691)",
    fill: "#030202",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.456,136.294s-36.4,23.8-40.876,29.4-14.839,32.756-14.839,37.516,6.159,54.035,6.159,54.035l-8.679,30.8s5.6,8.119,34.717,5.88,43.675-9.24,43.675-9.24S446.175,253.6,445.894,249.4s9.24-44.236,9.8-52.915-4.139-32.522-7-39.756A219.478,219.478,0,0,0,439.456,136.294Z",
    transform: "translate(-279.763 -53.654)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.922,76.64s-11.089,4.266-10.8,8.246,6.255,15.07,11.089,19.619,18.2,15.07,19.335,24.453-1.421,18.482-5.118,18.767l-3.7.283s1.422,6.824,14.218,8.815,27.3,1.706,34.4-10.521,5.4-39.238-1.706-51.749-24.736-20.187-34.4-21.609S395.922,76.64,395.922,76.64Z",
    transform: "translate(-278.598 -72.695)",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.716,179.251a74.268,74.268,0,0,1,5.681-7.118c4.76-5.039,12.039-8.679,12.039-8.679l3.08-5.039,2.8,1.12s7.839-5.04,13.718-9.519a41.14,41.14,0,0,0,8.4-8.12",
    transform: "translate(-276.621 -51.977)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.254,178.518s1.555-2.462,3.7-5.58",
    transform: "translate(-277.957 -42.683)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.2,160.736s-8.679,10.639-9.518,14.279-6.72,46.66-6.72,46.66-4.2,0-4.76,1.12-1.4,8.679-1.4,8.679-2.24,2.521-3.359,2.8l-42.556,6.719,1.96,16.8s27.157,0,34.717-.839,17.359,0,22.118-1.961c7-1.4,12.878-7.839,12.878-7.839l3.788-9.139s14.69-37.616,15.25-45.176a29.413,29.413,0,0,0-.572-9.84",
    transform: "translate(-286.15 -46.336)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(42.673)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.964 18.31)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M318.351,80.932s5.053,9.648,5.283,14.7-1.839,10.8-1.149,14.93,5.053,5.743,4.135,8.5-5.053,3.676-5.053,3.676-2.067,9.417-3.676,14.93-6.891,6.2-9.418,6.2-8.269-1.837-8.269-1.837l-2.756,15.85-31.01-22.512,2.527-13.553,5.053-9.417s-6.662-14.931-.69-25.5,16.31-14.011,27.794-15.39S318.351,80.932,318.351,80.932Z",
    transform: "translate(-266.438 -71.393)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.807,104.544a4.492,4.492,0,0,0,2.986,3.445c2.527.69,5.513-.919,5.513-.919s-2.3,9.418,1.837,14.7",
    transform: "translate(-263.633 -61.467)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.021,108.609s1.837,6.892,7.809,6.892",
    transform: "translate(-257.282 -60.25)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.617,89.889s2.986-2.526,7.121,1.149",
    transform: "translate(-255.906 -66.108)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.241,
    cy: 8.721,
    rx: 6.241,
    ry: 8.721,
    transform: "translate(44.713 26.323)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.2,100.608c0,1.587-.617,2.872-1.379,2.872s-1.379-1.285-1.379-2.872.617-2.87,1.379-2.87S307.2,99.023,307.2,100.608Z",
    transform: "translate(-255.059 -63.505)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 24.349,
    y1: 0.574,
    transform: "translate(19.984 35.496)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.118,126.763a12.574,12.574,0,0,1-3.9-1.837c-1.379-1.149-3.446-2.527-3.446-2.527l5.743,13.783Z",
    transform: "translate(-260.352 -56.122)",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("path", {
    d: "M319.265,85.151s-6.662-6.2-12.174-4.365-7.122,4.595-4.595,10.108,1.607,10.8-.919,12.4-10.567,2.987-11.485,4.595a15.467,15.467,0,0,1-2.756,3.216s-2.067-6.2-5.513-4.365-4.365,8.959-2.3,11.945l-9.647,7.349s.459-11.025-3.216-19.753-5.513-28.024,1.377-33.767,15.62-4.593,18.147-6.891,2.3-7.581,10.337-8.269,11.485,5.283,14.93,6.662,4.825-3.446,10.567.459,10.337,9.418,8.5,15.16S319.265,85.151,319.265,85.151Z",
    transform: "translate(-263.387 -57.302)",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("path", {
    d: "M258.872,381.962s-4.63,32.052-4.63,38.818-.712,27.9-.712,27.9-2.492,7.478-2.492,9.258.356,6.055.356,6.055l1.424,18.874h17.093s6.767-27.065,6.054-49.5-13.176-64.227-13.176-64.227Z",
    transform: "translate(-224.412 36.06)",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.578,245.626s.877,41.657,3.508,51.3,8.77,21.487,8.77,24.556,3.948,39.026,6.577,48.672-7.455,39.465-4.823,56.566S269.7,486.813,269.7,486.813s-1.754-.438-1.754,5.7v12.717l.439,14.909h18.854s-1.315-3.07,3.07-3.07,7.015,2.631,9.207,3.07,30.7,0,30.7,0,2.192-3.508,1.315-5.7-3.946-2.193-9.647-5.262-12.717-7.893-14.909-10.086-3.069-7.893-4.384-10.524-3.508-5.7-3.508-7.455,2.631-42.111,2.631-65.789,3.507-38.15,7.453-60.075,3.508-62.7,3.948-74.543,1.315-32.45,1.315-32.45Z",
    transform: "translate(-226.046 -0.919)",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.011,142.18s7.461,8.109,6.163,13.624a37.207,37.207,0,0,0-.973,10.055s7.786,12.976,8.434,36.656S312.5,259.28,312.5,259.28L305.04,275.5l-9.083-17.841s2.595-43.142,2.92-53.847.648-19.787-.65-26.275a97.855,97.855,0,0,1-1.622-12l-5.19-18.814Z",
    transform: "translate(-212.323 -31.89)",
    fill: "#739ffd",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.589,116.8l39.345,28.357-4.725,17.924-38.166-37.065Z",
    transform: "translate(-221.116 -39.489)",
    fill: "#8db0fc",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.52,123.89s-23.142,32.524-26.385,45.823-.973,38.277-.648,41.521,1.622,72.336,3.243,75.255,11.029,3.893,11.029,3.893h60.334s4.54-2.271,4.217-9.408-1.3-14.921-1.3-14.921.325-70.066-.324-79.473-12-29.842-12-29.842Z",
    transform: "translate(-227.593 -37.366)",
    fill: "#8db0fc",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(31.102 313.147)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M257.081,317.268a2.6,2.6,0,0,1-2.6-2.6V304.13a5.839,5.839,0,0,1,5.833-5.833h8.193a2.6,2.6,0,0,1,0,5.2h-8.193a.636.636,0,0,0-.635.635v10.539A2.6,2.6,0,0,1,257.081,317.268Z",
    transform: "translate(-254.482 -298.297)",
    fill: "#e0e0e0",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("path", {
    d: "M277.362,282.769s3.386,5.177,4.978,6.372,2.191,3.385,3.983,7.765a26.007,26.007,0,0,1,1.992,7.169s1.593,3.782,1.593,5.177-6.372,4.181-6.372,4.181.2,2.588-1,3.186-3.784,1.194-5.178.6-4.778-3.783-4.778-3.783a22.685,22.685,0,0,1-5.774-1.2c-2.588-1-5.576-1.593-7.169-3.783s-2.189-3.784-1.593-8.961,3.585-17.123,3.585-17.123Z",
    transform: "translate(-222.381 10.082)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.529,275.781s.4,9.558,1.393,10.155a22.768,22.768,0,0,0,10.355,1.992,28.957,28.957,0,0,0,8.363-2.389l-.2-9.358S262.914,277.573,259.529,275.781Z",
    transform: "translate(-221.869 8.109)",
    fill: "#8db0fc",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.8,146.05s-9.773,19.908-10.135,28.957,3.981,60.811,3.981,82.168,4.706,53.934,6.516,57.191,6.153,3.981,9.411,3.981,13.754,1.81,15.927-2.9,0-52.849,0-60.811,12.307-53.934,7.6-81.082",
    transform: "translate(-225.128 -30.731)",
    fill: "#8db0fc",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(60.765 313.147)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M286.863,298.3H278.67a2.58,2.58,0,0,0-1.359.392V303.1a2.569,2.569,0,0,0,1.359.394h8.193a.637.637,0,0,1,.637.635v10.539a2.6,2.6,0,1,0,5.2,0V304.13A5.839,5.839,0,0,0,286.863,298.3Z",
    transform: "translate(-277.311 -298.297)",
    fill: "#e0e0e0",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("rect", {
    width: 106.666,
    height: 77.234,
    rx: 4.825,
    transform: "translate(0 329.353)",
    fill: "#c3c3c3",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    x2: 0.214,
    y2: 7.907,
    transform: "translate(60.338 311.956)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFindTalent);
export default __webpack_public_path__ + "static/media/FindTalent.71367d86331e94f33ba26269817a84ab.svg";
export { ForwardRef as ReactComponent };